/*=========================================================================================
  File Name: moduleReportFormActions.js
  Description: Report Form Module Actions

==========================================================================================*/
import reportFormGQL from "@/http/requests/agile/form_gql.js";

export default {
	getReportForms({ commit }, payload) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.getReportForms(payload)
				.then(response => {
					commit("SET_REPORT_FORMS", response.data);
					commit("SET_TOTAL_REPORT_FORMS", response.total);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getReportForm({ commit }, id) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.getReportForm(id)
				.then(response => {
					commit("UPDATE_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	getReportFormSimpleData({ commit }, id) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.getReportFormSimpleData(id)
				.then(response => {
					commit("UPDATE_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	addReportForm({ commit }, payload) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.addReportForm(payload)
				.then(response => {
					commit("ADD_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	updateReportForm({ commit }, payload) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.updateReportForm(payload)
				.then(response => {
					commit("UPDATE_REPORT_FORM", response);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	deleteReportForm({ state, commit }, id) {
		return new Promise((resolve, reject) => {
			reportFormGQL
				.deleteReportForm(id)
				.then(response => {
					commit("DELETE_REPORT_FORM", id);
					commit("SET_TOTAL_REPORT_FORMS", state.total - 1);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	}
};
